'use strict';
import { fromJS } from 'immutable';
import {APARTMENTS, COMMERCIALS, GARAGES, LANDS, RENT, RENTDAILY, SALE} from '../consts';
import {
  SALE_APARTMENTS_HOME, SALE_LAND_HOME, SALE_COMMERCIALS_HOME, GARAGES_HOME,
  RENT_APARTMENTS_HOME, RENTDAILY_HOME, RENT_COMMERCIALS_HOME, RENT_APARTMENTS_HOUSE_COTTAGE,
  RENTDAILY_COTTAGE
} from '../utils/aliases';

const sections = fromJS({
  sale: {
    apartments: {
      id: 2,
      url: {
        home: SALE_APARTMENTS_HOME,
        base: '/pokupka-nedvizhimost/',
        search: '',
        card: '*-id:id/'
      }
    },
    lands: {
      id: 3,
      url: {
        home: SALE_LAND_HOME,
        base: '/pokupka-dachi-i-uchastki/',
        search: '',
        card: '*-id:id/'
      }
    },
    commercials: {
      id: 5,
      url: {
        home: SALE_COMMERCIALS_HOME,
        base: '/pokupka-kommercheskaja-nedvizhimost/',
        search: '',
        card: '*-id:id/'
      }
    },
    garages: {
      id: 4,
      url: {
        home: GARAGES_HOME,
        base: '/pokupka-garazhi/',
        search: '',
        card: '*-id:id/'
      }
    }
  },
  rent: {
    apartments: {
      id: 1,
      url: {
        home: RENT_APARTMENTS_HOME,
        base: '/arenda-nedvizhimost/',
        search: '',
        card: '*-id:id/'
      }
    },
    commercials: {
      id: 6,
      url: {
        home: RENT_COMMERCIALS_HOME,
        base: '/arenda-kommercheskaja-nedvizhimost/',
        search: '',
        card: '*-id:id/'
      }
    },
    lands: {
      url: {
        home: '/dachi-i-uchastki/',
        base: '/arenda-doma-kottedzhi/',
        search: '',
        card: '*-id:id/'
      }
    }
  },
  rentDaily: {
    apartments: {
      id: 11,
      url: {
        home: RENTDAILY_HOME,
        base: '/posutochnaja-arenda-nedvizhimost/',
        search: '',
        card: '*-id:id/'
      }
    },
    lands: {
      url: {
        home: '/dachi-i-uchastki/',
        base: '/posutochnaja-arenda-kottedzhi/',
        search: '',
        card: '*-id:id/'
      }
    }
  }
});

export const favoritesRubrics = [
  // 0-rubric_slug, 1-rubric_title, 2-count_announcement, 3-deal_type, 4-realty_type
  ['saleApartments', 'Квартир, комнат', 0, SALE, APARTMENTS],
  ['rentApartments', 'Квартир, комнат', 0, RENT, APARTMENTS],
  ['rentDailyApartments', 'Квартир посуточно', 0, RENTDAILY, APARTMENTS],
  ['saleCommercials', 'Коммерческой недвижимости', 0, SALE, COMMERCIALS],
  ['rentCommercials', 'Коммерческой недвижимости', 0, RENT, COMMERCIALS],
  ['saleLands', 'Домов, земельных участков', 0, SALE, LANDS],
  ['saleGarages', 'Гаражей', 0, SALE, GARAGES]
];

export const dealTypeSections = [
  // 0-section_slug, 1-section_title, 2-count_announcement
  ['sale', 'Продажа', 0],
  ['rent', 'Аренда', 0]
];

export const savedSearchRubrics = [
  // 0-rubric_slug, 1-rubric_title, 2-count_announcement, 3-deal_type, 4-realty_type
  ['saleApartments', 'Квартир, комнат', 0, SALE, APARTMENTS],
  ['rentApartments', 'Квартир, комнат', 0, RENT, APARTMENTS],
  ['rentDailyApartments', 'Квартир посуточно', 0, RENTDAILY, APARTMENTS],
  ['saleCommercials', 'Коммерческой недвижимости', 0, SALE, COMMERCIALS],
  ['rentCommercials', 'Коммерческой недвижимости', 0, RENT, COMMERCIALS],
  ['saleLands', 'Домов, земельных участков', 0, SALE, LANDS],
  ['saleGarages', 'Гаражей', 0, SALE, GARAGES]
];

export const savedSearchDealTypeTabsDealType = [
  // 0-rubric_slug, 1-rubric_title, 2-count_announcement, 3-deal_type, 4-realty_type
  ['sale', 'Продажа', 0, 'sale', 'apartments'],
  ['rent', 'Аренда', 0, 'rent', 'apartments']
];

export default function getSection (dealType, realtyType) {
  return sections.getIn([dealType, realtyType]);
}

function _findByPathName () {
  const pathList = {};

  sections.map((vd, kd) => {
    vd.map((vr, kr) => {
      const path = vr.getIn(['url', 'base']) + vr.getIn(['url', 'search']);

      pathList[path] = {
        dealType: kd,
        realtyType: kr,
        path
      };
    });
  });

  return function (pathName) {
    return pathList[pathName];
  };
}

export const findByPathName = _findByPathName();

export function getFavoritesStatistic (statistic, filtering = false) {
  return favoritesRubrics.map(tab => {
    tab[2] = statistic[tab[0]];
    return tab;
  }).filter(tab => filtering ? tab[2] : true);
}

export function getDealTypeSections (statistic, filtering = false) {
  const staticticList = Object.keys(statistic).map((key) => [key, statistic[key]]);
  return dealTypeSections.map(tab => {
    const sectionList = staticticList.filter(item => item[0].includes(tab[0]));
    tab[2] = sectionList.reduce((i, n) => i + n[1], 0);
    return tab;
  }).filter(tab => filtering ? tab[2] : true);
}
export function getSavedSearchStatistic (statistic, filtering = false) {
  return savedSearchRubrics.map(tab => {
    tab[2] = statistic[tab[0]];
    return tab;
  }).filter(tab => filtering ? tab[2] : true);
}

export function getSavedSearchStatisticDealType (statistic, filtering = false) {
  const staticticList = Object.keys(statistic).map((key) => [key, statistic[key]]);
  return savedSearchDealTypeTabsDealType.map(tab => {
    const sectionList = staticticList.filter(item => item[0].includes(tab[0]));
    tab[2] = sectionList.reduce((i, n) => i + n[1], 0);
    return tab;
  }).filter(tab => filtering ? tab[2] : true);
}



// WEBPACK FOOTER //
// ./src/utils/section.js